<template>
  <div class="app-wrapper">
    <div class="nav-wrapper">
      <navbar />
    </div>

    <!-- 内容区域 -->
    <div class="main-container">
      <router-view />
    </div>

    <!-- 底部 -->
    <div class="footer-wrapper">
      <app-footer />
    </div>
  </div>
</template>

<script>
import Navbar from './components/Navbar.vue'
import AppFooter from './components/Footer.vue'

export default {
  name: 'Layout',
  components: {
    Navbar,
    AppFooter
  }
}
</script>

<style lang="scss" scoped>
.app-wrapper {
  width: 100%;
  // height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  padding-top: 80px;
  background: #f5f7fa;
}

// 内容区域容器
.main-container {
  // max-width: 1300px;
  width: 100%;
  margin: 0 auto;
  flex: 1;
  // padding: 0px 130px;
}
</style>
